// 格式化处理耗时(秒数 → 友好中文)
export function formatDuration(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '—';
  if (seconds < 60) return `${Math.round(seconds)} 秒`;
  const m = Math.floor(seconds / 60);
  const s = Math.round(seconds % 60);
  if (m < 10) return s === 0 ? `${m} 分` : `${m} 分 ${s} 秒`;
  return `${m} 分`;
}
